const Builder = require('../BuilderBase');

module.exports = class MenuDivider extends Builder {
    constructor(title, properties) {
        super('menuSelection_MenuDivider', title, properties);
    }
};
